<template>
  <div class="toolbox_cont">
    <div
      style="align-items: center; border-radius: 10px; padding: 10px 10px"
      class="d-flex"
    >
      <div
        style="
          min-height: 60px;
          width: 100%;
          align-items: center;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #cacad4;
        "
      >
        <div class="d-flex" style="align-items: center">
          <span style="font-size: 12px; color: #ef4545; margin-right: 4px"
            >*</span
          >模型选择
        </div>
        <div style="margin-top: 6px; margin-bottom: 10px;flex-wrap: wrap; justify-content: flex-start">
          <span
            size="default"
            class="modelTypeBtn"
            round
            @click="changeModelType(1)"
            :class="{ active: formVuex.model_type == 1 }"
            style=" flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              line-height: 40px;
              width: 48%;
              height: 40px;
              border-radius: 20px;"
            >通用</span
          >
          <span
            size="default"
            class="modelTypeBtn"
            round
            @click="changeModelType(2)"
            :class="{ active: formVuex.model_type == 2 }"
            style=" flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              line-height: 40px;
              width: 48%;
              height: 40px;
              border-radius: 20px;"
            >二次元</span
          >
        </div>
      </div>
    </div>

    <div
      style="
        align-items: center;
        border-radius: 10px;
        padding: 10px 10px;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div
        style="
          min-width: 65px;
          align-items: center;
          margin-bottom: 6px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #cacad4;
        "
        class="d-flex"
      >
        风格选择
      </div>

      <div
        class="d-flex style_cont"
        style="flex-wrap: wrap; justify-content: flex-start"
      >
        <div
          class="model_cont_item"
          v-for="(item, sidx) in st_list_data"
          :key="sidx"
          @click="styleClick(item,sidx)"
          :class="{ active: styleIdx == sidx }"
          v-show="style_showMore ? true : sidx < 6"
        >
          <el-image style="width: 100%; height: 100%;margin-right: 5px;border-radius: 8px;" :src="item.icon" fit="contain" class="_image">
            <div slot="placeholder" class="image-slot"></div>
          </el-image>
          <!-- <span>{{ item.sname }}</span> -->
          <div class="name">
            {{ item.sname  }}
          </div>
        </div>
      </div>

      <div @click="style_showMore = !style_showMore"  v-if="st_list_data.length > 6" style="font-size: 13px;font-family: PingFangSC-Regular, PingFang SC;color: #CACAD4;text-align: center;padding-top: 4px;cursor: pointer;">
        <div v-if="!style_showMore">展开更多 <b-icon-chevron-down></b-icon-chevron-down> </div>
        <div v-else-if="style_showMore">收起 <b-icon-chevron-up></b-icon-chevron-up> </div>
      </div>
<!-- 
      <div
        style="align-items: center; margin-top: 10px"
        v-for="(item, idx) in styleSeletedList"
        :key="idx"
      >
        <div class="d-flex" style="align-items: center">
          <div
            style="
              min-width: 80px;
              flex: 1;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #cacad4;
            "
          >
            风格系数-{{ transStyle(item) }}
          </div>
          <span
            style="
              margin-left: 5px;
              border-radius: 4px;
              height: 30px;
              padding: 5px 10px;
              box-sizing: border-box;
              min-width: 50px;
              text-align: center;
              background-color: #252739;
              border: 1px solid #2c2f42;
            "
          >
            {{ styleSeletedRadioList[idx] }}</span
          >
        </div>
        <div style="padding: 0 10px 0 15px">
          <el-slider
            v-model="styleSeletedRadioList[idx]"
            :min="0"
            :max="1"
            :step="0.01"
          ></el-slider>
        </div>
      </div> -->
    </div>

    <div
      style="
        align-items: center;
        border-radius: 10px;
        padding: 10px 10px;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
     
      <div style="align-items: center; margin-top: 5px">
        <div class="d-flex" style="align-items: center">
          <div
            style="
              min-width: 80px;
              flex: 1;
              font-size: 14px;
              color: rgb(202, 202, 212);
              font-weight: 500;
              display: flex;
              align-items: center;
            "
          >
            <span
              style="
                font-size: 12px;
                color: #ef4545;
                margin-right: 4px;
                font-weight: 500;
              "
              >*</span
            >画面大小
          </div>
        </div>
        <div
          class="d-flex style_cont"
          style="
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 6px;
          "
        >
          <div
            @click="sizeClick(idx)"
            class="style_cont_item d-flex"
            v-for="(item, idx) in width_height_options_new"
            :class="{ active: widthIdx == idx }"
            :key="idx"
            style="
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 13px;
              line-height: 13px;
              height: 60px;
              width: 15%;
            "
          >
            <div style="margin-bottom: 4px">{{ item.text }}</div>
            <div>{{ item.desc }}</div>
          </div>
          <!-- -->
        </div>
        <div
          class="d-flex style_cont"
          style="
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 6px;
          "
        >
          <div
            @click="sizeValClick(didx)"
            class="style_cont_item size_cont_mult d-flex"
            v-for="(ditem, didx) in width_height_options_new[widthIdx].data"
            :key="didx"
            :class="{ active: widthDataIdx == didx }"
            style="
              flex-direction: column;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              line-height: 40px;
              width: 48%;
              height: 40px;
              border-radius: 20px;
            "
          >
            <div
              style="color: #fff; font-size: 14px; align-items: center"
              class="d-flex"
            >
              {{ ditem.value }}
              <div
                v-if="didx != 0 && !acData.vip"
                style="font-size: 12px; color: #9a9ab7; margin-left: 6px"
              >
                {{ ditem.desc }}积分/张
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex" style="margin-top: 10px">
        <div
          style="
            min-width: 80px;
            flex: 1;
            font-size: 14px;
            color: rgb(202, 202, 212);
            font-weight: 500;
            display: flex;
            align-items: center;
          "
        >
          允许作品在平台展示
        </div>
        <b-form-checkbox
          v-model="formVuex.is_public"
          :value="1"
          :unchecked-value="2"
        ></b-form-checkbox>
      </div>
    </div>

    
    <!-- <div
      style="
        align-items: center;
        background: #1b1d2e;
        border-radius: 10px;
        padding: 0px 10px;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <el-collapse accordion>
        <el-collapse-item :class="!acData.vip ? 'forbid' : 'unforbid'">
          <template slot="title">
            <div
              style="
                min-width: 228px;
                align-items: center;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                flex: 1;
              "
              class="d-flex _title"
            >
              <el-image
                style="width: 16px; height: 16px; margin-right: 5px"
                v-if="acData.vip"
                :src="require('../assets/img/textform/gjsz.png')"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>
              <el-image
                style="width: 16px; height: 16px; margin-right: 5px"
                v-else-if="!acData.vip"
                :src="require('../assets/img/textform/gjszForbid.png')"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot"></div>
              </el-image>

              高级设置
              <div style="flex: 1; justify-content: flex-end" class="d-flex">
                <div
                  style="
                    width: 44px;
                    height: 16px;
                    line-height: 16px;
                    background: linear-gradient(
                      315deg,
                      #006fff 0%,
                      #72e3f5 100%
                    );
                    border-radius: 12px;
                    text-align: center;
                  "
                >
                  <span
                    style="
                      color: #ffffff;
                      transform: scale(0.8, 0.8);
                      font-size: 12px;
                      display: inline-block;
                      width: 44px;
                    "
                    >VIP专享</span
                  >
                </div>
              </div>
            </div>
          </template>

          <div class="modal"></div>
          <div class="d-flex" style="margin-top: 11px; padding-left: 10px">
            <div style="flex: 1">高分辨率修复</div>
            <b-form-checkbox v-model="formVuex.enable_hr"> </b-form-checkbox>
          </div>

          <div
            style="
              align-items: center;
              margin-top: 10px;
              background-color: #1b1d2e;
            "
          >
            <div class="d-flex" style="align-items: center">
              <div
                style="
                  min-width: 80px;
                  flex: 1;
                  padding-left: 10px;
                  cursor: pointer;
                "
              >
                <el-tooltip
                  popper-class="tps"
                  class="item"
                  effect="dark"
                  :enterable="false"
                  content="大的步数意味着更高的画面精度，通常设置在20-40之间，过高的步数会导致速度变慢并产生扭曲效果"
                  placement="top-start"
                >
                  <span>步数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </div>
              <span
                style="
                  margin-left: 5px;
                  background-color: rgb(37, 39, 57);
                  border-radius: 4px;
                  height: 24px;
                  padding: 3px 19px;
                  box-sizing: border-box;
                  min-width: 50px;
                  text-align: center;
                "
                >{{ formVuex.steps }}</span
              >
            </div>
            <div style="padding: 0 10px 0 15px; margin-top: 5px">
              <el-slider
                v-model="formVuex.steps"
                :min="1"
                :max="40"
                :step="1"
              ></el-slider>
            </div>
          </div>

         

          <div style="align-items: center; margin-top: 20px">
            <div class="d-flex" style="align-items: center">
              <div style="min-width: 80px; flex: 1; padding-left: 10px">
                <el-tooltip
                  :enterable="false"
                  popper-class="tps"
                  class="item"
                  effect="dark"
                  content="影响算法对结果的影响，与原图的一致性大于0.7，一般是新效果；小于0.3一般变化不大"
                  placement="top-start"
                >
                  <span>重绘强度 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </div>
              <span
                style="
                  margin-left: 5px;
                  background-color: rgb(37, 39, 57);
                  border-radius: 4px;
                  height: 24px;
                  padding: 3px 19px;
                  box-sizing: border-box;
                  min-width: 50px;
                  text-align: center;
                "
                >{{ formVuex.denoising_strength }}</span
              >
            </div>
            <div style="padding: 0 10px 0 15px; margin-top: 5px">
              <el-slider
                v-model="formVuex.denoising_strength"
                :min="0"
                :max="1"
                :step="0.01"
              ></el-slider>
            </div>
          </div>

          <div
            style="
              align-items: center;
              background: #252739;
              border-radius: 10px;
              margin-top: 10px;
            "
            class="d-flex"
          >
            <div
              style="
                min-width: 105px;
                align-items: center;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #cacad4;
                padding-left: 10px;
                box-sizing: border-box;
              "
              class="d-flex"
            >
              <el-tooltip
                :enterable="false"
                popper-class="tps"
                class="item"
                effect="dark"
                content="高清重绘时的算法，不熟悉各算法区别时建议使用默认"
                placement="top-start"
              >
                <span>高清化算法 <i class="el-icon-question"></i></span>
              </el-tooltip>
            </div>
            <el-select
              v-model="formVuex.hr_upscaler"
              placeholder="请选择"
              popper-class="el_select_pop"
              class="el_select el_select2 el_select3"
              :popper-append-to-body="false"
              style="flex: 1"
            >
              <el-option
                v-for="item in hr_upscaler_options"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

      
          <div style="align-items: center; margin-top: 10px">
            <div class="d-flex" style="align-items: center">
              <div style="min-width: 80px; flex: 1; padding-left: 10px">
                <el-tooltip
                  :enterable="false"
                  popper-class="tps"
                  class="item"
                  effect="dark"
                  content="引导词与生成图片的相关性，数字越大相关性越强，但是创作表现越差；数值过大图像会出现错误，建议使用默认值"
                  placement="top-start"
                >
                  <span>提示词引导系数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </div>
              <span
                style="
                  margin-left: 5px;
                  background-color: rgb(37, 39, 57);
                  border-radius: 4px;
                  height: 24px;
                  padding: 3px 19px;
                  box-sizing: border-box;
                  min-width: 50px;
                  text-align: center;
                "
              >
                {{ formVuex.cfg_scale }}</span
              >
            </div>
            <div style="padding: 0 10px 0 15px; margin-top: 5px">
              <el-slider
                v-model="formVuex.cfg_scale"
                :min="1"
                :max="30"
                :step="1"
              ></el-slider>
            </div>
          </div>

          <div style="align-items: center; margin-top: 10px">
            <div class="d-flex" style="align-items: center">
              <div style="min-width: 80px; flex: 1; padding-left: 10px">
                <el-tooltip
                  :enterable="false"
                  popper-class="tps"
                  class="item"
                  effect="dark"
                  content="每次生成图的独立唯一编号，固定的种子数会每次生成一样的图片用于复现成果，-1代表随机生成"
                  placement="top-start"
                >
                  <span>种子数 <i class="el-icon-question"></i></span>
                </el-tooltip>
              </div>
             
            </div>
            <div style="padding: 0; border-radius: 10px; margin-top: 5px">
              <el-input
                style="background-color: #222337"
                v-model.number="formVuex.seed"
                maxlength="16"
              ></el-input>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div> -->
  </div>
</template>

<script>
import { md_list, st_list, feature_list } from "@/api/taskImage";
import {
  square_detail,
  like_edit_req,
  painting_download_req,
} from "@/api/square";

export default {
  props: {
    acData: {
      type: Object,
      default: {},
    },
    model_num: {
      type: Number,
      default: 9,
    },
  },
  data() {
    return {
      style_type:'',
      options: [],
      picoptions: [
        { text: "Orange", value: "orange" },
        { text: "Apple", value: "apple" },
      ],
      //宽高数据
      width_height_options: [
        { text: "1:1 头像图", value: "512:512" },
        { text: "4:3 文章配图", value: "512:384" },
        { text: "3:4 社交媒体", value: "384:512" },
        { text: "3:2 摄影作品", value: "512:341" },
        { text: "2:3 手机壁纸", value: "341:512" },
        { text: "16:9 电脑壁纸", value: "512:288" },
        { text: "9:16 宣传海报", value: "288:512" },
      ],
      width_height_options_new: [
        {
          text: "1:1",
          desc: "头像图",
          flag: false,
          point: 4,
          data: [
            {
              width: 512,
              height: 512,
              value: "512:512",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 512,
              value: "1024:1024",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "3:2",
          desc: "摄影作品",
          flag: false,
          point: 6,
          data: [
            {
              width: 512,
              height: 341,
              value: "512:341",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 341,
              value: "1024:682",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "2:3",
          desc: "手机壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 341,
              height: 512,
              value: "341:512",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 341,
              height: 512,
              value: "682:1024",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "4:3",
          desc: "文章配图",
          flag: false,
          point: 4,
          data: [
            {
              width: 512,
              height: 384,
              value: "512:384",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 384,
              value: "1024:768",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "3:4",
          desc: "社交媒体",
          flag: false,
          point: 4,
          data: [
            {
              width: 384,
              height: 512,
              value: "384:512",
              desc: 4,
              flag: false,
              hr_scale: 1,//是否高清
              enable_hr:false
            },
            {
              width: 384,
              height: 512,
              value: "768:1024",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "16:9",
          desc: "电脑壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 512,
              height: 288,
              value: "512:288",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 288,
              value: "1024:576",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "9:16",
          desc: "宣传海报",
          flag: false,
          point: 6,
          data: [
            {
              width: 288,
              height: 512,
              value: "288:512",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 288,
              height: 512,
              value: "576:1024",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
      ],
      width_height_options_new1: [
        {
          text: "1:1",
          desc: "头像图",
          flag: false,
          point: 4,
          data: [
            {
              width: 512,
              height: 512,
              value: "512:512",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 512,
              value: "1024:1024",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "3:2",
          desc: "摄影作品",
          flag: false,
          point: 6,
          data: [
            {
              width: 512,
              height: 341,
              value: "512:341",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 341,
              value: "1024:682",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "2:3",
          desc: "手机壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 341,
              height: 512,
              value: "341:512",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 341,
              height: 512,
              value: "682:1024",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "4:3",
          desc: "文章配图",
          flag: false,
          point: 4,
          data: [
            {
              width: 512,
              height: 384,
              value: "512:384",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 384,
              value: "1024:768",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "3:4",
          desc: "社交媒体",
          flag: false,
          point: 4,
          data: [
            {
              width: 384,
              height: 512,
              value: "384:512",
              desc: 4,
              flag: false,
              hr_scale: 1,//是否高清
              enable_hr:false
            },
            {
              width: 384,
              height: 512,
              value: "768:1024",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "16:9",
          desc: "电脑壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 512,
              height: 288,
              value: "512:288",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 512,
              height: 288,
              value: "1024:576",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
        {
          text: "9:16",
          desc: "宣传海报",
          flag: false,
          point: 6,
          data: [
            {
              width: 288,
              height: 512,
              value: "288:512",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 288,
              height: 512,
              value: "576:1024",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:true
            },
          ],
        },
      ],
      width_height_options_new2: [
        {
          text: "1:1",
          desc: "头像图",
          flag: false,
          point: 4,
          data: [
            {
              width: 576,
              height: 576,
              value: "576:576",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 1024,
              height: 1024,
              value: "1024:1024",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "3:2",
          desc: "摄影作品",
          flag: false,
          point: 6,
          data: [
            {
              width: 864,
              height: 576,
              value: "864:576",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 1296,
              height: 864,
              value: "1296:864",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "2:3",
          desc: "手机壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 576,
              height: 864,
              value: "576:864",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 864,
              height: 1296,
              value: "864:1296",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "4:3",
          desc: "文章配图",
          flag: false,
          point: 4,
          data: [
            {
              width: 768,
              height: 576,
              value: "768:576",
              desc: 4,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 1152,
              height: 864,
              value: "1152:864",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "3:4",
          desc: "社交媒体",
          flag: false,
          point: 4,
          data: [
            {
              width: 576,
              height: 768,
              value: "576:768",
              desc: 4,
              flag: false,
              hr_scale: 1,//是否高清
              enable_hr:false
            },
            {
              width: 864,
              height: 1152,
              value: "864:1152",
              desc: 8,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "16:9",
          desc: "电脑壁纸",
          flag: false,
          point: 6,
          data: [
            {
              width: 1024,
              height: 576,
              value: "1024:576",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 1440,
              height: 810,
              value: "1440:810",
              desc: 12,
              flag: false,
              hr_scale: 2,
              enable_hr:false
            },
          ],
        },
        {
          text: "9:16",
          desc: "宣传海报",
          flag: false,
          point: 6,
          data: [
            {
              width: 576,
              height: 1024,
              value: "576:1024",
              desc: 6,
              flag: false,
              hr_scale: 1,
              enable_hr:false
            },
            {
              width: 810,
              height: 1440,
              value: "810:1440",
              desc: 12,
              flag: false,
              hr_scale: 1.875,
              enable_hr:false
            },
          ],
        },
      ],
      sampler_name_options: [
        { text: "Euler a", value: "Euler a" },
        { text: "Euler", value: "Euler" },
        { text: "LMS", value: "LMS" },
        { text: "Heun", value: "Heun" },
        { text: "DPM2", value: "DPM2" },
        { text: "DPM2 a", value: "DPM2 a" },
        { text: "DPM++ 2S a", value: "DPM++ 2S a" },
        { text: "DPM++ 2M", value: "DPM++ 2M" },
        { text: "DPM++ SDE", value: "DPM++ SDE" },
        { text: "DPM fast", value: "DPM fast" },
        { text: "DPM adaptive", value: "DPM adaptive" },
        { text: "LMS Karras", value: "LMS Karras" },
        { text: "DPM2 Karras", value: "DPM2 Karras" },
        { text: "DPM2 a Karras", value: "DPM2 a Karras" },
        { text: "DPM++ 2S a Karras", value: "DPM++ 2S a Karras" },
        { text: "DPM++ 2M Karras", value: "DPM++ 2M Karras" },
        { text: "DPM++ SDE Karras", value: "DPM++ SDE Karras" },
        { text: "DDIM", value: "DDIM" },
        { text: "PLMS", value: "PLMS" },
        { text: "UniPC", value: "UniPC" },
      ],
      hr_upscaler_options: [
        { text: "Latent", value: "Latent" },
        { text: "Latent (antialiased)", value: "Latent (antialiased)" },
        { text: "Latent (bicubic)", value: "Latent (bicubic)" },
        {
          text: "Latent (bicubic antialiased)",
          value: "Latent (bicubic antialiased)",
        },
        { text: "Latent (nearest)", value: "Latent (nearest)" },
        { text: "Latent (nearest-exact)", value: "Latent (nearest-exact)" },
        { text: "None", value: "None" },
        { text: "LDSR", value: "LDSR" },
        { text: "Lanczos", value: "Lanczos" },
        { text: "Nearest", value: "Nearest" },
        { text: "ESRGAN_4x", value: "ESRGAN_4x" },
        { text: "R-ESRGAN 4x+", value: "R-ESRGAN 4x+" },
        { text: "R-ESRGAN 4x+ Anime6B", value: "R-ESRGAN 4x+ Anime6B" },
        { text: "ScuNET GAN", value: "ScuNET GAN" },
        { text: "ScuNET PSNR", value: "ScuNET PSNR" },
        { text: "SwimIR 4x", value: "SwimIR 4x" },
      ],

      styleVis: true,
      memberVis: false,
      fuVis: false,
      lazyLoad: false,
      md_list_data: [],
      st_list_data: [],
      feature_list_data: [],
      feature_category: 1,

      showMore: false,
      style_showMore: false,
      zhineng_showMore: false,
      styleIdx:0,

      widthIdx: 0,
      widthDataIdx: 0,
      styleSeletedList: [],
      styleSeletedRadioList: [],

      featureSeletedList: [],
      featureSeletedRadioList: [],
      featureCode1: [],
      featureCode2: [],
      featureCode3: [],
    };
  },
  computed: {
    formVuex: {
      get() {
        // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
        return this.$store.state.textImage.form;
      },
      set(newVal) {
        this.formVuex = newVal;
      },
    },
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
  mounted() {
    // if (this.tokenVuex) {
    //   if (this.$route.params && this.$route.params.id) {
    //     if (this.$route.params.style == "0") this.$route.params.style = 0;
    //     this.initParams();
    //   } else {
    //     this.formVuex.model_type = 1 ;
    //     this.md_list_req();
    //     this.formVuex.prompt = undefined;
    //     this.formVuex.width = 512;
    //     this.formVuex.height = 512;
    //     this.formVuex.batch_size = 1;

    //     this.width_height_options_new[0].flag = true ;
    //     this.width_height_options_new[0].data[0].flag = true ;
    //     this.widthIdx = 0 ;
    //     this.widthDataIdx = 0 ;
    //   }
    // }

    if (this.$route.params && this.$route.params.id) {
      if (this.$route.params.style == "0") this.$route.params.style = 0;
      this.initParams();
    } else {
      this.formVuex.model_type = 1;
      this.md_list_req();
      this.formVuex.prompt = undefined;
      this.formVuex.width = 512;
      this.formVuex.height = 512;
      this.formVuex.batch_size = 1;

      this.width_height_options_new[0].flag = true;
      this.width_height_options_new[0].data[0].flag = true;
      this.widthIdx = 0;
      this.widthDataIdx = 0;
      this.styleIdx = 0;
    }

    setTimeout(() => {
      this.lazyLoad = true;

      this.$nextTick(() => {
        this.pushTransPoint();
      });
    }, 300);
  },
  methods: {
    //初始参数赋值
    async initParams() {
      this.$route.params.width_height = `${this.$route.params.width}:${this.$route.params.height}`;
      this.formVuex.model_type = this.$route.params.model_type
        ? this.$route.params.model_type
        : 1;
      const { data, success } = await md_list({
        type: this.$route.params.model_type,
      });

      let featurearr = [];
      if (this.$route.params.feature_ratio) {
        this.$route.params.feature_ratio.split(",").forEach((item) => {
          featurearr.push(item - 0);
        });
        this.featureSeletedRadioList = featurearr;
        this.featureSeletedList = this.$route.params.feature.split(",");
      }

      if (success && data && data.length > 0) {
        this.md_list_data = data;
        //默认选择一个
        this.formVuex.model = this.$route.params.model;
        await this.modelChange(this.$route.params.model, true);

        if (this.$route.params.hr_scale) {
          this.$route.params.hr_scale = this.$route.params.hr_scale - 0;
        }
        if (this.$route.params.hr_second_pass_steps) {
          this.$route.params.hr_second_pass_steps =
            this.$route.params.hr_second_pass_steps - 0;
        }
        this.setConfig(this.$route.params);
        this.sizeClick(
          this.transSizeIdx(this.$route.params.width, this.$route.params.height)
        );
      }
    },
    //获取模型列表
    async md_list_req(param) {
      //console.log("md_list_req->this.formVuex.model_type",this.formVuex.model_type)
      const { data, success } = await md_list({
        type: this.formVuex.model_type,
      });
      if (success && data && data.length > 0) {
        //console.log("md_list_req.data",data);
        this.md_list_data = data;
        //默认选择一个
        if (param) {
          this.formVuex.model = param.model;
        } else {
          this.formVuex.model = this.md_list_data[0].type;
        }
        this.formVuex.model_name = this.md_list_data[0].code;
        this.formVuex.width_height = `${this.formVuex.width}:${this.formVuex.height}`;
        console.log("md_list_req.this.md_list_data[0].code",this.md_list_data[0].code)
        await this.modelChange(this.md_list_data[0].code, true, param);
      }
    },
    async st_list_req(pcode) {
      console.log("st_list_req.pcode",pcode)
      const { data, success } = await st_list({ pcode: pcode });
      this.st_list_data = data;
    },
    async feature_list_req(flag) {
      const { data, success } = await feature_list({
        type: this.formVuex.model_type,
      });
      if (success) {
        this.feature_list_data = data;
        this.featureSeletedList = [];
        this.featureCode1 = [];
        this.featureCode2 = [];
        this.featureCode3 = [];

        if (!flag) {
          this.featureSeletedRadioList = [];
        }
        this.feature_list_data.forEach((item) => {
          this.featureSeletedList.push(item.code);
          if (item.category == 1 && this.featureCode1.length < 3) {
            this.featureCode1.push(item.code);
          } else if (item.category == 2 && this.featureCode2.length < 3) {
            this.featureCode2.push(item.code);
          } else if (item.category == 3 && this.featureCode3.length < 3) {
            this.featureCode3.push(item.code);
          }
          if (!flag) {
            this.featureSeletedRadioList.push(0);
          }
        });

        // this.featureSeletedList = [] ;
        // this.featureSeletedRadioList = [] ;
      } else {
        this.feature_list_data = [];
        this.featureSeletedList = [];
        this.featureSeletedRadioList = [];
      }
    },
    changeFeatureCategory(category) {
      // this.feature_list_data = []
      // this.featureSeletedList = [] ;
      // this.featureSeletedRadioList = [] ;
      this.feature_category = category;
      this.formVuex.feature_category = category;
    },
    resetFeature(idx) {
      this.featureSeletedRadioList[idx] = 0;
      this.$forceUpdate();
    },
    getFeatureData() {
      return {
        featureSeletedList: this.featureSeletedList,
        featureSeletedRadioList: this.featureSeletedRadioList,
      };
    },

    async modelClick(code) {
      this.formVuex.model = code;
      await this.modelChange(code);
    },
    async modelChange(value, flag, param) {
      //console.log("modelChange.value",value)
      if (!value) {
        console.log("modelChange.value",value);
        this.st_list_data = [];
        this.formVuex.style = 0;
        
        return;
      }
      //赋值
 /*      let config;
      this.md_list_data.forEach((val) => {
        if (val.code == value) {
          config = JSON.parse(val.config);
          if (config.hr_scale) {
            config.hr_scale = config.hr_scale - 0;
          }
          if (config.hr_second_pass_steps) {
            config.hr_second_pass_steps = config.hr_second_pass_steps - 0;
          }
          config.style = undefined;
          config.style_ratio = undefined;
        }
      });
      this.setConfig(config, param); */
      //model改变
      await this.st_list_req(value);
      /* if (!param) {
        this.styleSeletedList = [];
        this.styleSeletedRadioList = [];
      } */
      this.sizeValClick(0);

      //await this.feature_list_req(flag);
    },

    styleClick(value,sidx) {
      //console.log("styleClick.value",value);
      this.formVuex.style_name = value.scode
      console.log("this.formVuex.style_name",this.formVuex)
      this.styleIdx = sidx;
      
    },
    //点击不限
    styleCancelClick() {
      this.styleSeletedList = [];
      this.styleSeletedRadioList = [];

      // let config;
      // this.md_list_data.forEach(val => {
      //   if (val.code == this.formVuex.model) {
      //     config = JSON.parse(val.config)
      //     console.log( config )
      //     if (config.hr_scale) {
      //       config.hr_scale = config.hr_scale - 0;
      //     }
      //     if (config.hr_second_pass_steps) {
      //       config.hr_second_pass_steps = config.hr_second_pass_steps - 0;
      //     }
      //     config.style = undefined;
      //   }
      // })
      // this.setConfig(config);
    },
    getStyleData() {
      return {
        styleSeletedList: this.styleSeletedList,
        styleSeletedRadioList: this.styleSeletedRadioList,
      };
    },
    setStyleData(data, params) {
      setTimeout(() => {
        this.st_list_data.forEach((item) => {
          if (data.styleSeletedList.includes(item.scode)) {
            this.styleSeletedList.push(item.scode);
          }
        });
        data.styleSeletedRadioList.forEach((item) => {
          this.styleSeletedRadioList.push(Number(item));
        });
        this.width_height_options_new.forEach((item, i) => {
          item.data.forEach((data, j) => {
            if (data.value === `${params.width}:${params.height}`) {
              this.widthDataIdx = j;
              this.widthIdx = i;
            }
          });
        });
        let arr = [];
        data.featureSeletedRadioList.forEach((item) => {
          arr.push(item - 0);
        });
        this.featureSeletedRadioList = arr;
        this.formVuex.model_type = params.model_type;
        this.formVuex.batch_size = params.batch_size;
        this.formVuex.restore_faces = params.restore_faces;
        this.formVuex.is_public = params.is_public;
        this.feature_category = params.feature_category || 1;
        this.formVuex.feature_category = params.feature_category || 1;
        this.formVuex.enable_hr = params.enable_hr;
        this.formVuex.steps = params.steps;
        this.formVuex.sampler_name = params.sampler_name;
        this.formVuex.denoising_strength = params.denoising_strength;
        this.formVuex.hr_scale = params.hr_scale;
        this.formVuex.hr_second_pass_steps = params.hr_second_pass_steps;
        this.formVuex.hr_upscaler = params.hr_upscaler;
        this.formVuex.negative_prompt = params.negative_prompt;
        this.formVuex.cfg_scale = params.cfg_scale;
        this.formVuex.seed = params.seed;
        this.changeModelType(params.model_type, params);
      }, 1000);
    },
    // styleChange(value) {
    //   if (!value) {
    //     let config;
    //     this.md_list_data.forEach(val => {
    //       if (val.code == this.formVuex.model) {
    //         config = JSON.parse(val.sconfig)
    //         if (config.hr_scale) {
    //           config.hr_scale = config.hr_scale - 0;
    //         }
    //         if (config.hr_second_pass_steps) {
    //           config.hr_second_pass_steps = config.hr_second_pass_steps - 0;
    //         }
    //       }
    //     })
    //     this.setConfig(config);
    //     return;
    //   }
    //   //赋值
    //   let config;
    //   this.st_list_data.forEach(val => {
    //     if (val.scode == value) {
    //       config = JSON.parse(val.sconfig)
    //       if (config.hr_scale) {
    //         config.hr_scale = config.hr_scale - 0;
    //       }
    //       if (config.hr_second_pass_steps) {
    //         config.hr_second_pass_steps = config.hr_second_pass_steps - 0;
    //       }
    //     }
    //   })
    //   this.setConfig(config);
    // },
    async setConfig(config, param) {
      let arr = [];
      for (let k in config) {
        if (k != "width" && k != "height" && k != "batch_size") {
          this.formVuex[k] = config[k];
        }
      }
      if (!this.formVuex.style) {
        this.formVuex.style = undefined;
      } else {
        config.style_ratio.split(",").forEach((item) => {
          arr.push(item - 0);
        });
      }
      setTimeout(() => {
        this.formVuex.hr_scale = config.hr_scale;
        this.formVuex.enable_hr = config.enable_hr;
        if (!param) {
          this.styleSeletedRadioList = arr;
        }
        if (config && config.style) {
          this.styleSeletedList = config.style.split(",");
        }

        if (config.width && config.height) {
          this.formVuex.width_height = `${config.width}:${config.height}`;
        }
        if (!this.formVuex.hr_second_pass_steps) {
          this.formVuex.hr_second_pass_steps = 0;
        }
        if (!this.formVuex.denoising_strength) {
          this.formVuex.denoising_strength = 0.45;
        }
        if (!this.formVuex.hr_scale) {
          this.formVuex.hr_scale = 1.25;
        }
        if (!this.formVuex.hr_upscaler) {
          this.formVuex.hr_upscaler = "Latent";
        }
        if (!this.formVuex.cfg_scale) {
          this.formVuex.cfg_scale = 7;
        }
        if (this.$route.params._id) {
          square_detail(this.$route.params._id).then((res) => {
            this.formVuex.prompt = JSON.parse(res.data.request).prompt;
            this.$forceUpdate();
          });
        }

        this.$forceUpdate();
      }, 30);
    },

    widthChange(value) {
      // console.log( value  )
      this.formVuex.width = value.split(":")[0] - 0;
      this.formVuex.height = value.split(":")[1] - 0;
    },
    sizeClick(idx) {
      this.widthIdx = idx;
      this.sizeValClick(0);
    },
    sizeValClick(idx) {
      this.widthDataIdx = idx;
      this.formVuex.hr_scale =
        this.width_height_options_new[this.widthIdx].data[
          this.widthDataIdx
        ].hr_scale;
      if (idx > 0) {
        this.formVuex.enable_hr = true;
      } else {
        this.formVuex.enable_hr = false;
      }
      this.formVuex.width =
        this.width_height_options_new[this.widthIdx].data[
          this.widthDataIdx
        ].width;
      this.formVuex.height =
        this.width_height_options_new[this.widthIdx].data[
          this.widthDataIdx
        ].height;

      this.$emit(
        "pushTransPoint",
        this.formVuex.batch_size *
          this.width_height_options_new[this.widthIdx].data[this.widthDataIdx]
            .desc
      );
    },

    // 当label值为空，想要选中空的label值
    toStr(str) {
      // console.log( str )
      return str;
    },
    changeModelType(val, params) {
      //console.log("changeModelType=",params)
      if(val == 1){
        console.log("if changeModelType.val",val)
        this.width_height_options_new = this.width_height_options_new1;
        
      }else{
        console.log("else changeModelType.val",val)
        console.log("else changeModelType.val",val)
        this.width_height_options_new = this.width_height_options_new2;
      }
      this.width_height_options_new[0].flag = true;
      this.width_height_options_new[0].data[0].flag = true;
      this.widthIdx = 0;
      this.widthDataIdx = 0;
      //this.width_height_options_new = this.width_height_options_new;
      //console.log("this.width_height_options_new",this.width_height_options_new)
      this.formVuex.model_type = val;
      //console.log("changeModelType.val",val)
      //console.log("changeModelType.params",params)
      this.md_list_req(params);
    },
    transStyle(code) {
      let str = "";
      this.st_list_data.forEach((val) => {
        if (val.scode == code) {
          str = val.sname;
        }
      });
      return str;
    },
    hrScaleChange() {
      this.widthDataIdx = 0;
      // this.formVuex.enable_hr = false ;
    },
    transSizeIdx(width, height) {
      if (Math.round((width / height) * 100) / 100.0 == 1) {
        // 1 :1
        return 0;
      } else if (Math.round((width / height) * 100) / 100.0 == 0.5) {
        return 1;
      } else if (Math.round((width / height) * 100) / 100.0 == 1.33) {
        return 2;
      } else if (Math.round((width / height) * 100) / 100.0 == 0.75) {
        return 3;
      } else if (Math.round((width / height) * 100) / 100.0 == 1.78) {
        return 4;
      } else if (Math.round((width / height) * 100) / 100.0 == 0.56) {
        return 5;
      }
      return 0;
    },
    isShow(item, idx) {
      if (this.zhineng_showMore) {
        return true;
      } else {
        if (this.feature_category == 1) {
          if (this.featureCode1.indexOf(item.code) > -1) {
            return true;
          } else {
            return false;
          }
        } else if (this.feature_category == 2) {
          if (this.featureCode2.indexOf(item.code) > -1) {
            return true;
          } else {
            return false;
          }
        } else if (this.feature_category == 3) {
          if (this.featureCode3.indexOf(item.code) > -1) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    pushTransPoint() {
      // console.log(this.width_height_options_new  )
      // console.log( this.widthIdx )
      // console.log( this.widthDataIdx )
      this.$emit(
        "pushTransPoint",
        this.formVuex.batch_size *
          this.width_height_options_new[this.widthIdx].data[this.widthDataIdx]
            .desc
      );
    },
    changebatch_size(val) {
      this.formVuex.batch_size = val;
      this.$emit(
        "pushTransPoint",
        this.formVuex.batch_size *
          this.width_height_options_new[this.widthIdx].data[this.widthDataIdx]
            .desc
      );
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el_select {
  // height: 20px;
  width: 300px;

  .el-input__inner {
    background-color: #1b1d2e;
    border: none;
    text-align: right;
  }

  .el-scrollbar__wrap {
    background: #1b1d2e;
    border: none;
  }

  .el-scrollbar {
    border: 1px solid #2c2f42;
    padding: 3px 0;
    background: #1b1d2d;
  }
}

::v-deep .el_select2 {
  .el-input__inner {
    background-color: #252739;
    border: none;
    text-align: right;
  }
}

::v-deep .el_select3 {
  .el-select-dropdown {
    right: 0 !important;
    left: auto !important;
    width: 230px;
  }
}

::v-deep .el-input__inner {
  background-color: #252739;
  border: none;
  // text-align: right;
  border-radius: 10px;
  color: #fff;
}

::v-deep .el-select-dropdown {
  background-color: #1b1d2e;

  color: #9a9ab7;

  .el-select-dropdown__item {
  }

  .el-select-dropdown__wrap.el-scrollbar__wrap {
    margin-bottom: -15px !important;
  }

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: #252739;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    border-radius: 6px;
  }

  .el-select-dropdown__item.selected.hover {
    color: #fff !important;
  }
}

::v-deep .el-slider__bar {
  background-color: #006fff;
}

::v-deep .el-slider__button {
  border: solid 2px #006fff;
}

::v-deep .el-collapse {
  border-top: none;
}

::v-deep .el-collapse-item__header {
  background-color: #1b1d2e;
  color: #fff;
  border-bottom: none;
}

::v-deep .el-collapse-item__content {
  background-color: #1b1d2e;
  color: rgb(130, 130, 146);
  padding: 0 0 10px 0;
  box-sizing: border-box;
}

::v-deep .el-collapse-item__wrap {
  border-bottom: none;
  background-color: #1b1d2e;
}

::v-deep .el-textarea__inner {
  background-color: #252739;
  border: none;
  padding: 0 0;
  color: #fff;
}
::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #252739;
  border: none;
  padding: 0 0;
  color: #fff;
  padding: 0 5px;
  box-sizing: border-box;
}

::v-deep .el-select-dropdown__list {
  padding: 0px 8px !important;
}

::v-deep .forbid .el-collapse-item__wrap {
  position: relative;
  .modal {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(27, 29, 46, 0.5);
    z-index: 600;
    display: block;
  }
}

::v-deep .unforbid .el-collapse-item__header {
  color: #fff;
  ._title {
    color: #cacad4;
  }
}
::v-deep .forbid .el-collapse-item__header {
  color: #595868;
  ._title {
    color: #595868;
  }
}

.content {
  box-sizing: border-box;
  max-height: calc(100% - 10px);

  .toolbox {
    text-align: left;
    padding: 12px;
    box-sizing: border-box;
    font-size: 14px;
    overflow: hidden;
    height: 100%;
    padding-right: 20px;
    /* 防止滚动条遮挡内容 */
  }
}

.toolbox_cont {
  text-align: left;
  .el-slider__button-wrapper {
    z-index: 0 !important;
  }
}

.title {
  font-weight: 700;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 2px solid #317cf6;
}

.icon-item {
  width: 25%;
  margin-bottom: 12px;

  .icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #51a280;
    margin: 0 auto;
  }

  .name {
    font-size: 12px;
    text-align: center;
    margin-top: 3px;
  }

  .toolbox {
    overflow: hidden;
  }

  .toolbox::-webkit-scrollbar {
    width: 2px;
    display: flex;
  }

  .toolbox::-webkit-scrollbar-thumb {
  }

  .toolbox:hover {
    overflow-y: auto;
    width: calc(100% - 2px);
  }

  .tool-main {
    .tool-main-cont {
      justify-content: center;
      align-items: center;
    }
  }
}

.modelTypeBtn {
  background: #25293c !important;
  color: #cacad4;
  border: none;
  height: 20px;
  line-height: 20px;
  background: #25293c;
  border-radius: 10px;
  text-align: center;
  padding: 0 11px;
  font-size: 12px;
  margin-right: 4px;
  display: inline-block;
  cursor: pointer;
}

.modelTypeBtn.active {
  background: #006fff !important;
  color: #ffffff;
}

.img-cont {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: #f5f6f9;
  margin: 0 auto;
}

.bottom-cont {
  background: #fff;
  border-radius: 20px;
  border: 1px solid #bbbcbc;
  padding-left: 10px;
  box-sizing: border-box;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 10px;
  margin-bottom: 10px;

  textarea {
    border: none;
    resize: none;
    cursor: pointer;
  }
}
.batch_size_btn {
  width: 100px;
  height: 40px;
  line-height: 40px;
  background: rgb(37, 39, 57);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
  display: block;
  cursor: pointer;
  margin-right: 10px;
}
.batch_size_btn.active {
  background: #006fff;
  color: #fff;
  line-height: 40px;
}

.style_cont {
  .model_cont_item {
    width: 76px;
    height: 76px;
    border-radius: 8px;
    margin-right: 8px;
    margin-bottom: 10px;
    position: relative;

    .name {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 24px;
      line-height: 24px;
      width: 100%;
      -webkit-backdrop-filter: blur(5px);
      backdrop-filter: blur(5px);
      border-radius: 0 0 8px 8px;
      overflow: hidden;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
    }
  }

  .style_cont_item {
    width: 80px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    margin-right: 8px;
    margin-bottom: 10px;
    position: relative;
    background: #252739;
    color: #cacad4;
    cursor: pointer;
    font-size: 14px;
  }

  .style_cont_item.active {
    background: #006fff;
    box-sizing: border-box;
    color: #ffffff;
  }

  .model_cont_item.active {
    border: 2px solid #006fff;
    box-sizing: border-box;
  }
}
</style>
